/* Dripcoffee · add a suggested product from the cart without leaving it */
(function () {
  if (customElements.get('dc-cart-upsell')) return;

  class DcCartUpsell extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => {
        const btn = event.target.closest('.dc-upsell__add');
        if (!btn || btn.disabled) return;
        this.add(btn);
      });
    }

    async add(btn) {
      const error = this.querySelector('.dc-upsell__error');
      const drawer = this.dataset.context === 'drawer' ? document.querySelector('cart-drawer') : null;
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      if (error) error.hidden = true;

      const body = { items: [{ id: Number(btn.dataset.variantId), quantity: 1 }] };
      if (drawer) {
        body.sections = drawer.getSectionsToRender().map((s) => s.id);
        body.sections_url = window.location.pathname;
      }

      try {
        const res = await fetch(`${window.routes ? window.routes.cart_add_url : '/cart/add'}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || 'No se pudo agregar');

        if (drawer && data.sections) {
          // Re-renders the whole drawer: items, totals, bar and these suggestions
          drawer.renderContents(data);
        } else {
          window.location.reload();
        }
      } catch (e) {
        if (error) {
          error.textContent = e.message;
          error.hidden = false;
        }
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
      }
    }
  }

  customElements.define('dc-cart-upsell', DcCartUpsell);
})();
